import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log('Activity index controller connected')
    this.reloadScheduled = false
    this.modalOpen = false

    // Listen for Turbo Stream render events (from broadcasts)
    document.addEventListener('turbo:before-stream-render', this.handleStreamRender.bind(this))

    // Track modal open/close state
    document.addEventListener('shown.bs.modal', this.handleModalOpen.bind(this))
    document.addEventListener('hidden.bs.modal', this.handleModalClose.bind(this))
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.handleStreamRender.bind(this))
    document.removeEventListener('shown.bs.modal', this.handleModalOpen.bind(this))
    document.removeEventListener('hidden.bs.modal', this.handleModalClose.bind(this))
  }

  handleModalOpen(event) {
    if (event.target.id && event.target.id.startsWith('newActivityModal')) {
      console.log('Modal opened')
      this.modalOpen = true
    }
  }

  handleModalClose(event) {
    if (event.target.id && event.target.id.startsWith('newActivityModal')) {
      console.log('Modal closed')
      this.modalOpen = false

      // If a reload was scheduled while the modal was open, do it now
      if (this.reloadScheduled) {
        console.log('Executing scheduled reload...')
        this.reloadScheduled = false
        window.Turbo.visit(window.location.href, { action: 'replace' })
      }
    }
  }

  handleStreamRender(event) {
    // Check if this is our refresh trigger
    const target = event.target.getAttribute('target')
    if (target === 'activity_refresh_trigger') {
      console.log('Broadcast received')

      // Prevent the actual stream from rendering (we don't need to add the element)
      event.preventDefault()

      // If a modal is open, schedule the reload for when it closes
      // Otherwise, reload immediately
      if (this.modalOpen) {
        console.log('Modal is open, scheduling reload for when modal closes')
        this.reloadScheduled = true
      } else {
        console.log('No modal open, reloading page...')
        // Reload the page to show updated activities
        // Using Turbo visit for smooth transition
        window.Turbo.visit(window.location.href, { action: 'replace' })
      }
    }
  }
}
